import { connect } from 'react-redux';

/**
 * 权限显影简单包装
 * @param {Object} props
 * @param {string} props.resource 资源
 * @returns
 */
function PermWrapper({ perms, resource, children }) {
  return perms.includes(resource) ? children : null;
}

export default connect((state) => ({
  perms: state.auth.perms || [],
}))(PermWrapper);
